















import { Component, Vue } from "vue-property-decorator";
import KaRewardSummary from "./kaRewardSummary/index.vue";
import KaRewardDetail from "./kaRewardDetail/index.vue";

@Component({
  components: {
    KaRewardSummary,
    KaRewardDetail
  }
})
export default class KaRewardIndex extends Vue {
  tabList: any[] = [
    { value: "0", label: "奖励金汇总统计" },
    { value: "1", label: "奖励金明细统计" }
  ];
  activeName: string = "0";
}
